var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9516 17.2042C12.2395 17.0298 12.4487 16.7411 12.5333 16.4017C12.6179 16.0622 12.571 15.6998 12.4028 15.3941L11.7686 14.2416C11.6004 13.9359 11.3247 13.7121 11.0023 13.6192C10.6798 13.5264 10.3369 13.5722 10.0491 13.7465C7.87837 15.0615 6.60999 12.7564 5.97581 11.6039C5.34162 10.4514 4.07324 8.14631 6.24393 6.83135C6.53178 6.65697 6.74103 6.36831 6.82563 6.02887C6.91024 5.68943 6.86328 5.327 6.69509 5.02133L6.0609 3.8688C5.8927 3.56313 5.61705 3.33925 5.29457 3.24641C4.9721 3.15357 4.62922 3.19937 4.34137 3.37375C1.62801 5.01744 0.634187 7.1562 3.80512 12.9189C6.97605 18.6815 9.23825 18.8478 11.9516 17.2042Z",
    stroke: "#444545",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.728 12.4448C18.3046 10.1268 17.9833 7.65245 16.8349 5.5654C15.6865 3.47835 13.8048 1.94929 11.6034 1.31416M14.405 11.4881C14.5768 10.7996 14.618 10.0808 14.5263 9.37271C14.4347 8.66458 14.2119 7.981 13.8707 7.36104C13.5296 6.74107 13.0768 6.19685 12.5381 5.75949C11.9995 5.32212 11.3856 5.00016 10.7315 4.81201M11.0999 10.5244C11.2152 10.0606 11.1509 9.56549 10.9211 9.14789C10.6913 8.73029 10.3148 8.4243 9.87435 8.29712",
    stroke: "#444545",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphn);
export default __webpack_public_path__ + "static/media/headphn.92443d7e68ae45651e1eb5dc6230db9e.svg";
export { ForwardRef as ReactComponent };